import { createTheme } from '@mantine/core';


export const theme = createTheme({
	colors: {
		'themed': [
			"#e7fdf5",
			"#d8f5ea",
			"#b3e8d5",
			"#8adabe",
			"#69cfaa",
			"#53c89e",
			"#46c597",
			"#34aa80",
			"#299b73",
			"#118662"
		],
		'themed-black': [
			"#dce7f1",
			"#b4cde6",
			"#8ab2db",
			"#679bd2",
			"#528dcc",
			"#4686cb",
			"#3873b4",
			"#2e66a1",
			"#164068",
			"#0d2842"
		] as any
	},
	components: {
		Button: {
			defaultProps: {
				bdrs: 0,
			},
		},
		Container: {
			defaultProps: {
				size: "1124px",
			},
		},
		Title: {
			defaultProps: {
				c: "themed-black.8",
			},
		},
	},
});